module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS13.19ad4650.jpg";